// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1683":"c83a3e7d","3629":"b5f58125","6406":"56d9025d"}[chunkId] || chunkId) + ".99051fd289170df7.js";
};